var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _text;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCanfar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 512 512",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 144 80 L 166 102 L 144 124 L 122 102 L 144 80 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 38 234 L 60 256 L 38 278 L 16 256 L 38 234 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 144 388 L 166 410 L 144 432 L 122 410 L 144 388 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 102 146 L 126 146 L 126 170 L 102 170 L 102 146 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 62 206 L 86 206 L 86 230 L 62 230 L 62 206 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 62 282 L 86 282 L 86 306 L 62 306 L 62 282 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 102 342 L 126 342 L 126 366 L 102 366 L 102 342 Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 60 256 L 110 256"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 86 230 L 110 256"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 86 282 L 110 256"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 144 124 L 144 220"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 126 170 L 144 220"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 126 342 L 144 292"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 144 388 L 144 292"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 292,
    stroke: "none",
    fontSize: "76pt",
    fill: "currentColor",
    fontFamily: "Arial, Helvetica, sans-serif"
  }, "CANFAR")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanfar);
export default __webpack_public_path__ + "static/media/canfar.0d1761c6e4910ca9d2c2baa314df111f.svg";
export { ForwardRef as ReactComponent };